import { styled, Typography } from '@mui/material';

const SectionContainer = styled('div')(({ theme }) => ({
  padding: theme.spacing(),
}));

const SectionTitle = styled(Typography)(({ theme }) => ({
  marginBottom: theme.spacing(),
}));

const SectionContent = styled('div')(({ theme }) => ({
  margin: theme.spacing(),
  '& > MuiFormControl-root': {
    display: 'block',
  },
}));

export default function Section({ title, children }) {
  return (
    <SectionContainer>
      <SectionTitle variant="h5">{title}</SectionTitle>

      <SectionContent>{children}</SectionContent>
    </SectionContainer>
  );
}
